import popular from './fetchPopular';
import addTrack from './addTrack';

export default {
  popular,
  addTrack
};
